var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAviva(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.324219 10.3496C0.324219 4.82676 4.80137 0.349609 10.3242 0.349609H38.3242C43.8471 0.349609 48.3242 4.82676 48.3242 10.3496V38.3496C48.3242 43.8725 43.8471 48.3496 38.3242 48.3496H10.3242C4.80137 48.3496 0.324219 43.8725 0.324219 38.3496V10.3496Z",
    fill: "url(#paint0_linear_4168_5866)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3242 25.3501C32.3242 30.3501 28.8242 32.8501 24.6642 34.3001C24.4464 34.3739 24.2098 34.3703 23.9942 34.2901C19.8242 32.8501 16.3242 30.3501 16.3242 25.3501V18.3501C16.3242 18.0848 16.4296 17.8305 16.6171 17.643C16.8046 17.4554 17.059 17.3501 17.3242 17.3501C19.3242 17.3501 21.8242 16.1501 23.5642 14.6301C23.7761 14.4491 24.0456 14.3496 24.3242 14.3496C24.6029 14.3496 24.8724 14.4491 25.0842 14.6301C26.8342 16.1601 29.3242 17.3501 31.3242 17.3501C31.5894 17.3501 31.8438 17.4554 32.0313 17.643C32.2189 17.8305 32.3242 18.0848 32.3242 18.3501V25.3501Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4168_5866",
    x1: 24.3242,
    y1: 0.349609,
    x2: 24.3242,
    y2: 48.3496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#155DFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60A5FA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAviva);
export default __webpack_public_path__ + "static/media/AVIVA.7298222cb2649742f34d4e525ae3d8a5.svg";
export { ForwardRef as ReactComponent };